import { useMutation } from '@tanstack/react-query';
import { useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';

import Api from '@barboxx/api';
import { ServingContainer } from '@barboxx/models';
import { useBool } from '@barboxx/react-utils';

interface Props {
    servingContainer: ServingContainer;
}

export const ServingContainerDeleteCard = ({ servingContainer }: Props) => {
    const notifications = useNotifications();
    const navigate = useNavigate();
    const [open, dialogActions] = useBool();

    const mutateDeleteServingContainer = useMutation({
        mutationKey: ['deleteServingContainer', servingContainer.id],
        mutationFn: () =>
            Api.Servings.ServingContainer.deleteServingContainer(
                servingContainer
            ),
    });

    const onDelete = async () => {
        mutateDeleteServingContainer
            .mutateAsync()
            .then(({ data }) => {
                notifications.show('Deleted serving container!', {
                    severity: 'success',
                });
                navigate(-1);
            })
            .catch(e => {
                notifications.show('Error deleting serving container!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete Serving Container" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this serving container
                        and all associated Products with it?
                    </Typography>

                    <Button
                        onClick={dialogActions.on}
                        color="error"
                        variant="outlined"
                    >
                        Delete
                    </Button>
                </Stack>
            </CardContent>
            <Dialog
                open={open}
                onClose={dialogActions.off}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    Delete Serving Container
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this serving container!
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={dialogActions.off} color="inherit">
                        Cancel
                    </Button>

                    <Button
                        onClick={onDelete}
                        color="error"
                        variant="contained"
                        loading={mutateDeleteServingContainer.isPending}
                        autoFocus
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Card>
    );
};
